import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  INQUIRY_ALL,
  INQUIRY_ASSIGNED,
  INQUIRY_COMMENTS,
  INQUIRY_COMMENT_CREATE,
  INQUIRY_COMMENT_DELETE,
  INQUIRY_CREATE,
  INQUIRY_DELETE,
  INQUIRY_ITEM,
  INQUIRY_LIST,
  INQUIRY_PUBLIC_INFO,
  INQUIRY_UPDATE_STATUS,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const INQUIRY = GLOBAL_STATE

const inquirySlice = createSlice({
  name: INQUIRY,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.inquiryAll.pending, state => {
        state[INQUIRY_ALL].loading = true
      })
      .addCase(actionCreators.inquiryAll.rejected, (state, action) => {
        state[INQUIRY_ALL].loading = false
        state[INQUIRY_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryAll.fulfilled, (state, action) => {
        state[INQUIRY_ALL].loading = false
        state[INQUIRY_ALL].error = null
        state[INQUIRY_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryAssigned.pending, state => {
        state[INQUIRY_ASSIGNED].loading = true
      })
      .addCase(actionCreators.inquiryAssigned.rejected, (state, action) => {
        state[INQUIRY_ASSIGNED].loading = false
        state[INQUIRY_ASSIGNED].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryAssigned.fulfilled, (state, action) => {
        state[INQUIRY_ASSIGNED].loading = false
        state[INQUIRY_ASSIGNED].error = null
        state[INQUIRY_ASSIGNED].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryCreate.pending, state => {
        state[INQUIRY_CREATE].loading = true
      })
      .addCase(actionCreators.inquiryCreate.rejected, (state, action) => {
        state[INQUIRY_CREATE].loading = false
        state[INQUIRY_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryCreate.fulfilled, (state, action) => {
        state[INQUIRY_CREATE].loading = false
        state[INQUIRY_CREATE].error = null
        state[INQUIRY_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryItem.pending, state => {
        state[INQUIRY_ITEM].loading = true
      })
      .addCase(actionCreators.inquiryItem.rejected, (state, action) => {
        state[INQUIRY_ITEM].loading = false
        state[INQUIRY_ITEM].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryItem.fulfilled, (state, action) => {
        state[INQUIRY_ITEM].loading = false
        state[INQUIRY_ITEM].error = null
        state[INQUIRY_ITEM].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryItemDelete.pending, state => {
        state[INQUIRY_DELETE].loading = true
      })
      .addCase(actionCreators.inquiryItemDelete.rejected, (state, action) => {
        state[INQUIRY_DELETE].loading = false
        state[INQUIRY_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryItemDelete.fulfilled, (state, action) => {
        state[INQUIRY_DELETE].loading = false
        state[INQUIRY_DELETE].error = null
        state[INQUIRY_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryList.pending, state => {
        state[INQUIRY_LIST].loading = true
      })
      .addCase(actionCreators.inquiryList.rejected, (state, action) => {
        state[INQUIRY_LIST].loading = false
        state[INQUIRY_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryList.fulfilled, (state, action) => {
        state[INQUIRY_LIST].loading = false
        state[INQUIRY_LIST].error = null
        state[INQUIRY_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryUpdateStatus.pending, state => {
        state[INQUIRY_UPDATE_STATUS].loading = true
      })
      .addCase(actionCreators.inquiryUpdateStatus.rejected, (state, action) => {
        state[INQUIRY_UPDATE_STATUS].loading = false
        state[INQUIRY_UPDATE_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryUpdateStatus.fulfilled, (state, action) => {
        state[INQUIRY_UPDATE_STATUS].loading = false
        state[INQUIRY_UPDATE_STATUS].error = null
        state[INQUIRY_UPDATE_STATUS].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryComments.pending, state => {
        state[INQUIRY_COMMENTS].loading = true
      })
      .addCase(actionCreators.inquiryComments.rejected, (state, action) => {
        state[INQUIRY_COMMENTS].loading = false
        state[INQUIRY_COMMENTS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryComments.fulfilled, (state, action) => {
        state[INQUIRY_COMMENTS].loading = false
        state[INQUIRY_COMMENTS].error = null
        state[INQUIRY_COMMENTS].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryCommentCreate.pending, state => {
        state[INQUIRY_COMMENT_CREATE].loading = true
      })
      .addCase(actionCreators.inquiryCommentCreate.rejected, (state, action) => {
        state[INQUIRY_COMMENT_CREATE].loading = false
        state[INQUIRY_COMMENT_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryCommentCreate.fulfilled, (state, action) => {
        state[INQUIRY_COMMENT_CREATE].loading = false
        state[INQUIRY_COMMENT_CREATE].error = null
        state[INQUIRY_COMMENT_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryCommentDelete.pending, state => {
        state[INQUIRY_COMMENT_DELETE].loading = true
      })
      .addCase(actionCreators.inquiryCommentDelete.rejected, (state, action) => {
        state[INQUIRY_COMMENT_DELETE].loading = false
        state[INQUIRY_COMMENT_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryCommentDelete.fulfilled, (state, action) => {
        state[INQUIRY_COMMENT_DELETE].loading = false
        state[INQUIRY_COMMENT_DELETE].error = null
        state[INQUIRY_COMMENT_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.inquiryPublicInfo.pending, state => {
        state[INQUIRY_PUBLIC_INFO].loading = true
      })
      .addCase(actionCreators.inquiryPublicInfo.rejected, (state, action) => {
        state[INQUIRY_PUBLIC_INFO].loading = false
        state[INQUIRY_PUBLIC_INFO].error = action.payload as AxiosError
      })
      .addCase(actionCreators.inquiryPublicInfo.fulfilled, (state, action) => {
        state[INQUIRY_PUBLIC_INFO].loading = false
        state[INQUIRY_PUBLIC_INFO].error = null
        state[INQUIRY_PUBLIC_INFO].data = action.payload
      })

    builder.addCase(actionCreators.inquiryAllClear, state => {
      state[INQUIRY_ALL] = defaultState()
    })

    builder.addCase(actionCreators.inquiryAssignedClear, state => {
      state[INQUIRY_ASSIGNED] = defaultState()
    })

    builder.addCase(actionCreators.inquiryItemClear, state => {
      state[INQUIRY_ITEM] = defaultState()
    })

    builder.addCase(actionCreators.inquiryListClear, state => {
      state[INQUIRY_LIST] = defaultState()
    })

    builder.addCase(actionCreators.inquiryCommentsClear, state => {
      state[INQUIRY_COMMENTS] = defaultState()
    })

    builder.addCase(actionCreators.inquiryPublicInfoClear, state => {
      state[INQUIRY_PUBLIC_INFO] = defaultState()
    })
  },
})

export const { reducer: inquiryReducer } = inquirySlice
